module.exports = {
  message: {
    test: 'test',
    main:'HOME',
    about:'ABOUT',
    works:'WORKS',
    build:'ARCHITECTURE',
    indoor:'INTERIOR',
    design:'DESIGN',
    vision:'VISUAL',
    report:'PRESS',
    news:'NEWS',
    publication:'PUBLICATIONS',
    contact:'CONTACT',
    generalEnquiries:'GENERAL ENQUIRIES',
    marketing: 'MARKETING & PRESS',
    career: 'CAREER OPPORTUNITIES',
    all:'ALL',
    private:'PRIVATE',
    public:'PUBLIC',
    down:'Scroll',
    more:"MORE",
    video:'VIDEO',
    infro:'INFO',
    awards:'AWARDS'
  }
}
